module Meevo.Plugins.Register {
    "use strict";
    export enum GiftCardStageEnum {
        Quantity,
        Single,
        Bulk,
        GiftCardType
    }
    export enum GiftCardRefundTypeEnum {
        Single,
        Bulk
    }
    interface IGiftCardSaleCheck {
        isMatch: boolean,
        giftCard: any,
        giftCards?: any[]
    }
    export class GiftCardSection extends Meevo.Plugins.Register.RegisterSectionBase {

        get $translate() { return this.registerContext.$translate; }
        get $timeout() { return this.registerContext.$timeout; }

        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }
        get securityService() { return this.registerContext.securityService; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.GiftCard, registerContext, "giftCard", Register.RegisterSectionCatTypeEnum.Sale);

            this.transactionSaleLines = new Components.BaseClasses.PagedResults<Model.SaleLine, any>(this.dataService, "ClientGiftCard", this.onSearch);
            this.bulkSaleLines = new Components.BaseClasses.PagedResults<Model.SaleLine, any>(this.dataService, "saleLine", this.onSearch);

            this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.DATA_STUDENTTEACHERMODULE + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(result => {
                this.canViewStudentTeacherModule = result === Meevo.Model.SecurityAccessEnum.Grant;
            });
            this.getGiftCardTypesAll()
                .then(() => {
                    this.setDefaultGiftCardType();
                });
            
        }
        stage: Meevo.Plugins.Register.GiftCardStageEnum;
        giftCard: any;
        giftCardNumber: string;
        giftCardId: string;
        existing: boolean;
        existingAmount: number;
        client: Model.ClientListItem = null;
        scannedTransactionId: string = "";
        giftCardNumberSaleRegEx: RegExp = new RegExp("^[0-9A-Za-z]+$");
        giftCardNumberEntered: boolean = false;
        giftCardTypesAll: Model.GiftCardType[];
        giftCardTypes: Model.GiftCardType[];
        defaultGiftCardType: Model.GiftCardType;
        giftCardTypeFilters;
        giftCardTypeFilter;
        autoGenerateGcNumber: boolean;
        saleType: Model.SalesTypeEnum;
        initialStage: Meevo.Plugins.Register.GiftCardStageEnum;
        quantity: number;
        saleLine: Model.SaleLine;
        isChangingGiftCardNumber: boolean;
        isSaving: boolean;
        refundType: GiftCardRefundTypeEnum;
        previousRefundType: GiftCardRefundTypeEnum;
        singleRefundType = {
            refundTypeEnum: GiftCardRefundTypeEnum.Single,
            label: this.$translate.instant("LABEL_GIFT_CARD_REFUND_SINGLE")
        };
        multiRefundType = {
            refundTypeEnum: GiftCardRefundTypeEnum.Bulk,
            label: this.$translate.instant("LABEL_GIFT_CARD_REFUND_MULTI")
        }
        public refundTypeList = [];
        canRefundSingle: Model.SecurityItem;
        canRefundBulk: Model.SecurityItem;
        pregeneratedGiftCardItem: any;

        private get anonymousClient(): any {
            return {
                id: undefined,
                clientType: Model.ClientTypeEnum.AnonymousOther,
                displayName: this.$translate.instant("LABEL_GIFTCARD_PURCHASED_FOR_ANONYMOUS")
            }
        }

        public refundTypeChanged(isAuto : boolean = false) {
            if (angular.isUndefined(this.refundType)) {
                return;
            }
            let canAccessAction = () => {
                this.previousRefundType = this.refundType;
                this.refundSubTotal = 0;
                this.refundTax = 0;
                if (this.request) {
                    if (this.refundType === GiftCardRefundTypeEnum.Single) {
                        this.transactionSaleLines.initSearch(this.request);
                    }
                    else {
                        this.request.criteria.saleType = Model.SalesTypeEnum.BulkGiftCard;
                        if (this.request.criteria.clientIds && this.request.criteria.clientIds.length > 0) {
                            this.request.criteria.clientId = this.request.criteria.clientIds[0];
                        }
                        this.bulkSaleLines.initSearch(this.request);
                    }
                }
            }

            let selectedSecurityItem = this.refundType === GiftCardRefundTypeEnum.Single ?
                this.canRefundSingle : this.canRefundBulk;

            if (selectedSecurityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant || isAuto) {
                canAccessAction();
            }
            else {
                let defer = this.registerContext.$q.defer();
                defer.promise.then(() => {
                    canAccessAction();
                }).catch(() => {
                    this.refundType = this.previousRefundType;
                });
                this.registerContext.$rootScope.$emit(Meevo.Components.Common.Messages.ELEVATION_CHALLENGE, defer,
                    selectedSecurityItem.key.replace(/:/gi, '_'), selectedSecurityItem.displayName,
                    this.registerContext.identityService.current().userName, selectedSecurityItem.securityKeyPath);
            }
        }
        isPriceChanged: boolean = false;

        selectedReferredByEnum: Meevo.Model.ReferredByEnum;
        selectedReferredByDetail: Meevo.Model.ReferralDetail;
        securityKeys = Meevo.Components.Common.SecurityKeys;
        canViewStudentTeacherModule: boolean = false;
        globalTypeaheadCriteria: any = { isGlobal: true };

        private addGiftCard(giftCard: any, saleType: Model.SalesTypeEnum, isRefund: boolean) {
            if (this.saleLine) {
                if (!this.saleLine.isRefund) {
                    if (giftCard.value != giftCard.price) {
                        const isGiftCardTypeDiscount = giftCard.price < giftCard.value;
                        this.registerContext.registerDiscountService.handlePriceChangeDiscount(this.registerContext, this.saleLine, giftCard.price, 0, isGiftCardTypeDiscount);
                    } else {
                        const lastSpecialPriceIndex = this.registerContext.registerDiscountService.getLastSpecialPriceIndex(this.saleLine.discountLines);
                        if (lastSpecialPriceIndex !== -1) {
                            this.saleLine.discountLines.splice(lastSpecialPriceIndex, 1);
                        }
                    }
                }

                let clone = jQuery.extend(true, {}, this.saleLine);
                this.saleLine.quantity = this.quantity;
                this.saleLine.baseItemPrice = giftCard.value;
                this.saleLine.finalItemPrice = giftCard.price;
                this.saleLine.isDirty = true;
                this.giftCard.giftCardNumber = this.giftCardNumber;
                let item = <GiftCardSaleLineItem>this.saleLine.item;
                item.autoGenerateGiftCardNumber = this.autoGenerateGcNumber && !this.pregeneratedGiftCardItem;
                item.remainingAmount = this.registerContext.normalizeDecimalPlaces(giftCard.remainingAmount * this.quantity);
                item.remainingRefundAmount = this.registerContext.normalizeDecimalPlaces(giftCard.remainingRefundAmount * this.quantity);
                item.clientGiftCard = this.giftCard;
                item.isGiftCardNumberUnmasked = !!this.pregeneratedGiftCardItem;
                this.assignGiftCardNumber(this.saleLine.saleType, item);

                if (saleType === Model.SalesTypeEnum.BulkGiftCard) {
                    (this.saleLine.item as Model.GiftCardBulkSaleLineItem).giftCardNumberStarting = null;
                    (this.saleLine.item as Model.GiftCardBulkSaleLineItem).giftCardNumberEnding = null;
                }

                this.registerContext.recalculateSale()
                    .then(() => {
                        this.reset();
                    }).catch(() => {
                        this.registerContext.sale.saleLines.splice(_(this.registerContext.sale.saleLines).indexOf(this.saleLine),
                            1, clone);
                        this.saleLine = clone;
                    });
            }
            else {
                var saleLine = this.getSaleLine(saleType, isRefund, giftCard);

                this.registerContext.tempSaleLines = [saleLine];
                this.registerContext.selectSection(RegisterSectionTypeEnum.Employee);
            }
            this.autoGenerateGcNumber = false;
        }

        getSaleLine(saleType: Model.SalesTypeEnum, isRefund: boolean = false, giftCard?: any, forceGenerateGcNumber = false): Model.SaleLine {
            giftCard = giftCard || this.giftCard;
            let baseItem = {
                id: giftCard.id,
                autoGenerateGiftCardNumber: this.autoGenerateGcNumber && (!this.pregeneratedGiftCardItem || forceGenerateGcNumber),
                isGiftCardNumberUnmasked: !!this.pregeneratedGiftCardItem,
                note: giftCard.note
            }
            let giftCardSaleItem = saleType === Model.SalesTypeEnum.BulkGiftCard ?
                new Meevo.Plugins.Register.GiftCardBulkSaleLineItem({
                    ...baseItem,
                    displayName: this.$translate.instant("LABEL_MULTI_GIFT_CARD"),
                    remainingAmount: this.registerContext.normalizeDecimalPlaces(giftCard.remainingAmount * this.quantity),
                    remainingRefundAmount: this.registerContext.normalizeDecimalPlaces(giftCard.remainingRefundAmount * this.quantity),
                    isGiftCardNumberUnmasked: !!this.pregeneratedGiftCardItem
                }) :
                new Meevo.Plugins.Register.GiftCardSaleLineItem({
                    ...baseItem,
                    displayName: `${this.$translate.instant("LABEL_GIFT_CARD")} : ${!giftCard.id ? this.$translate.instant("LABEL_NEW") : this.$translate.instant("LABEL_EXISTING_CARD")}`
                });
            
            giftCardSaleItem.clientGiftCard = jQuery.extend(true, {}, giftCard);
            this.assignGiftCardNumber(saleType, giftCardSaleItem);
            
            giftCardSaleItem.clientGiftCard.giftCardNumber = giftCardSaleItem.clientGiftCard.maskedGiftCardNumber
                || giftCardSaleItem.clientGiftCard.giftCardNumber;

            let saleLine: Model.SaleLine = {
                item: giftCardSaleItem,
                quantity: this.saleType === Model.SalesTypeEnum.BulkGiftCard ? this.quantity : 1,
                baseItemPrice: giftCard.value,
                finalItemPrice: giftCard.price,
                client: this.registerContext.selectedClient,
                clientId: this.registerContext.selectedClient ? this.registerContext.selectedClient.id : undefined,
                clientType: this.registerContext.selectedClientType,
                saleType: saleType,
                isNew: this.registerContext.selectedClientType === Model.ClientTypeEnum.Client,
                isRefund: isRefund,
                showPoleMessage: Model.SaleLineStatusEnum.Added,
                referredByDetail: this.selectedReferredByDetail
            };

            if (!isRefund && saleLine.baseItemPrice != saleLine.finalItemPrice) {
                const isGiftCardTypeDiscount = giftCard.price < giftCard.value;
                this.registerContext.registerDiscountService.handlePriceChangeDiscount(this.registerContext, saleLine, saleLine.finalItemPrice, 0, isGiftCardTypeDiscount);
            }

            return saleLine;
        }

        priceChanged() {
            if (this.giftCard.giftCardType &&
                this.giftCard.giftCardType.isPromo &&
                this.giftCard.giftCardType.valuePrice > 0
            ) {
                if (this.giftCard.remainingAmount > this.giftCard.giftCardType.valuePrice) {
                    this.giftCard.remainingAmount = this.giftCard.giftCardType.valuePrice;
                }
            }
            
            if (!this.giftCard.giftCardTypeId 
                || this.existing 
                || (this.giftCard.giftCardType && !this.giftCard.giftCardType.isPromo)
            ) {
                //when coming from GC Type and not changing GC Value, we want to use GC config Default Price. If Value changed at least once, we use whatever Value is selected, even if it is back to GC Type defaul Value
                if (this.giftCard.giftCardType && this.giftCard.remainingAmount == this.giftCard.giftCardType.valuePrice && !this.isPriceChanged) {
                    this.giftCard.price = this.giftCard.giftCardType.defaultPrice;
                    this.giftCard.value = this.giftCard.giftCardType.valuePrice;
                }
                else {
                    this.giftCard.price = this.giftCard.remainingAmount;
                    this.giftCard.value = this.giftCard.remainingAmount;
                }
            }
            this.isPriceChanged = true;
        }

        edit(saleLine: Model.SaleLine) {
            this.registerContext.hideCheckoutButtons = true;
            this.saleLine = saleLine;
            this.giftCard = (<GiftCardSaleLineItem>saleLine.item).clientGiftCard;
            if (this.giftCard.giftCardType) {
                this.giftCard.price = this.giftCard.giftCardType.defaultPrice;
            }
            if (!this.giftCard.client.id) {
                this.useAnonymousClient(this.giftCard);
            }
            this.saleType = saleLine.saleType;
            this.stage = GiftCardStageEnum.Bulk;
            this.quantity = saleLine.quantity;
            this.giftCardNumber = this.giftCard.giftCardNumber;
            this.autoGenerateGcNumber = (<GiftCardSaleLineItem>saleLine.item).autoGenerateGiftCardNumber;
            this.selectedReferredByDetail = saleLine.referredByDetail;
            this.selectedReferredByEnum = saleLine.referredByDetail.referredBy;
        }

        save(isValid) {
            if (!isValid) {
                return;
            }

            if (this.isChangingGiftCardNumber) {
                this.isSaving = true;
                return;
            }
            this.isSaving = false;

            if (this.giftCard.remainingAmount <= 0) {
                this.modalService.alert("MESSAGE_GIFTCARD_VALID_AMOUNT");
                return;
            }

            this.giftCard.remainingRefundAmount = this.giftCard.price;
            
            this.priceChanged();

            if (this.saleType != Model.SalesTypeEnum.BulkGiftCard) {
                this.assignGiftCardNumber(this.saleType);
                this.saleType = this.existing && this.giftCard.id ? Model.SalesTypeEnum.ReloadGiftCard : Model.SalesTypeEnum.GiftCard;
            }

            this.addGiftCard(this.giftCard, this.saleType, false);
            this.registerContext.displayNotification(false);
            this.registerContext.hideCheckoutButtons = false;
        }

        giftCardNumberChange() {
            this.isChangingGiftCardNumber = false;
            this.$timeout(() => {
                this.giftCardNumberEntered = true;
            });

            if (!this.giftCardId && (!this.giftCardNumber || String(this.giftCardNumber).trim() === "") && !this.autoGenerateGcNumber) {
                this.giftCard = undefined;
                this.registerContext.giftCardTypeChanged(undefined);
                return;
            }
            
            if ((this.giftCard != undefined && this.giftCard.giftCardNumber === this.giftCardNumber) && !this.autoGenerateGcNumber) {
                return;
            }
            this.giftCardId = undefined;

            const isGiftCardFormatInvalid = (this.giftCardNumber && this.stage == GiftCardStageEnum.Bulk && this.giftCardNumber.match("^.+?\\d$") == null) && !this.autoGenerateGcNumber;
            if (isGiftCardFormatInvalid) {
                this.showGiftCardErrorMessageAndReset("MESSAGE_GIFT_CARD_MUST_END_WITH_NUMBER");
                return;
            }

            const isGiftCardNumberInSale = _(this.registerContext.sale.saleLines)
                .any(sl => !this.autoGenerateGcNumber &&
                    !(sl.item as any).autoGenerateGiftCardNumber &&
                    (sl.item as any).clientGiftCard && (sl.item as any).clientGiftCard.giftCardNumber === this.giftCardNumber);
            if (isGiftCardNumberInSale) {
                this.showGiftCardErrorMessageAndReset("MESSAGE_GIFT_CARD_MUST_BE_UNIQUE");
                return;
            }

            const requestCheckBin: any = {
                prefix: this.giftCardNumber
            };

            this.isChangingGiftCardNumber = true;
            this.dataService.customMethodData(`/api/Tenant/GiftCardExternalBin/CheckBin`, 'POST', requestCheckBin).then((responseCheckBin: any) =>
            {
                return this.handleCheckBinResponse(responseCheckBin);
                }).
                finally(() => {
                    this.isChangingGiftCardNumber = false;
                    if (this.saleLine && this.giftCardNumber && this.isSaving) {
                        this.save(true);
                    }
                });
            this.minEndDate = null;
        }

        loadGiftCard(id) {
            this.reset();
            this.giftCardId = id;
            this.generateGiftCard();
        }

        private showGiftCardErrorMessageAndReset(message: any) {
            this.modalService.alert(this.$translate.instant(message));
            this.giftCardNumber = undefined;
            this.giftCard = undefined;
        }

        private handleCheckBinResponse(responseCheckBin) : any {
            if (!_.isEmpty(responseCheckBin.data.prefix)) {
                const message = this.$translate.instant("MESSAGE_THIRD_PARTY_GIFT_CARD_NUMBER", { bin: responseCheckBin.data.prefix });
                this.giftCardNumber = undefined;
                this.giftCard = undefined;
                return this.modalService.alert(message);
            }

            this.generateGiftCard(true);
        }
        
        private generateGiftCard(checkGiftCardIdInSale: boolean = false) {
            const request: any = {
                pageNumber: 0,
                itemsPerPage: 10000,
                criteria: {
                    giftCardNumber: this.giftCardId || this.giftCardNumber,
                    overrideSearchGiftCardByGUID: angular.isDefined(this.giftCardId),
                    nonZeroBalanceOnly: null,
                    activeOnly: null,
                    autoGenerateGiftCardNumber: this.autoGenerateGcNumber,
                    disableWildCardGiftCardSearch: !this.registerContext.allowGiftCardReload,
                }
            };

            let checkGiftCardFutureDate = (giftCards, giftCard):IGiftCardSaleCheck => {
                let existingGiftCardWithFutureDate = _(giftCards).find((giftCard) => !giftCard.isActive);
                if (existingGiftCardWithFutureDate) {
                    this.modalService.alert("MESSAGE_FUTURE_GIFT_CARD_RELOAD");
                    this.giftCardNumber = undefined;
                    return { isMatch: true, giftCard:undefined };
                }
                return { isMatch: false, giftCard };
            }

            let checkGiftCardUsageRestriction = (giftCards, giftCard):IGiftCardSaleCheck => {
                let allowedGiftCards = _(giftCards).reject((card: any) =>
                    !this.registerContext.registerGiftCardService.checkGCUsageRestriction(card));
            
                if (allowedGiftCards.length === 0) {
                    this.modalService.alert("MESSAGE_REGISTER_GIFT_CARD_RESTRICTED_ACROSS_LOCATIONS")
                    this.giftCardNumber = undefined;
                    return { isMatch: true, giftCard:undefined, giftCards: allowedGiftCards };
                }
                return { isMatch: false, giftCard, giftCards: allowedGiftCards };
            }

            let checkGiftCardWithBalance = (giftCards, giftCard) => {
                let existingGiftCardWithBalance = _(giftCards).find((giftCard) => giftCard.remainingAmount > 0);
                if (existingGiftCardWithBalance) {
                    if (this.saleType === Model.SalesTypeEnum.BulkGiftCard) {
                        this.modalService.alert("MESSAGE_MULTI_GIFT_CARD_RELOAD");
                        this.giftCardNumber = undefined;
                        if (!this.saleLine) {
                            giftCard = undefined;
                        }
                        return { isMatch: true, giftCard };
                    }
                    else if (existingGiftCardWithBalance.isPromo) {
                        this.modalService.alert("MESSAGE_PROMO_GIFT_CARD_RELOAD");
                        this.giftCardNumber = undefined;
                        return { isMatch: true, giftCard:undefined };
                    } else if (!this.registerContext.allowGiftCardReload) {
                        this.modalService.alert("MESSAGE_GIFT_CARD_RELOAD_NOT_ALLOWED");
                        this.giftCardNumber = undefined;
                        return { isMatch: true, giftCard: undefined };
                    } else {
                        this.existingAmount = existingGiftCardWithBalance.remainingAmount;

                        if (existingGiftCardWithBalance.clientId != undefined) {
                            giftCard.client = {
                                id: existingGiftCardWithBalance.clientId,
                                firstName: existingGiftCardWithBalance.clientFirstName,
                                lastName: existingGiftCardWithBalance.clientLastName,
                                displayName: existingGiftCardWithBalance.clientDisplayName,
                                primaryPhoneNumber: existingGiftCardWithBalance.clientPhoneNumber
                            }
                            giftCard.clientId = existingGiftCardWithBalance.clientId;
                            giftCard.clientType = Model.ClientTypeEnum.Client;
                        } else {
                            this.useAnonymousClient(giftCard);
                        }

                        if (existingGiftCardWithBalance.giftCardTypeId != undefined) {
                            giftCard.giftCardType = {
                                displayName: existingGiftCardWithBalance.giftCardTypeDisplayName,
                                id: existingGiftCardWithBalance.giftCardTypeId
                            }
                            giftCard.giftCardTypeId = existingGiftCardWithBalance.giftCardTypeId;
                        }

                        if (existingGiftCardWithBalance.remainingAmount !== 0) {
                            giftCard.id = existingGiftCardWithBalance.id;
                        }

                        giftCard.maskedGiftCardNumber = existingGiftCardWithBalance.giftCardNumber;
                        giftCard.note = existingGiftCardWithBalance.note;
                        giftCard.saleDate = existingGiftCardWithBalance.saleDate;
                        giftCard.saleLocationId = existingGiftCardWithBalance.saleLocationId;
                        giftCard.saleId = existingGiftCardWithBalance.saleId;
                        giftCard.saleLineId = existingGiftCardWithBalance.saleLineId;
                        this.existing = true;

                        return { isMatch: true, giftCard };
                    }
                } 
                return { isMatch: false, giftCard };
            }

            let checkReuseGiftCard = (giftCards, giftCard) => {
                if (!this.registerContext.allowGiftCardReuse) {
                    this.modalService.alert("MESSAGE_GIFT_CARD_RESELL_NOT_ALLOWED");
                    this.giftCardNumber = undefined;
                    return { isMatch: true, giftCard: undefined };
                }
                return { isMatch: false, giftCard };
            }

            if (!this.autoGenerateGcNumber) {
                return this.dataService.getListPaged("ClientGiftCard", request).then((giftCards: any) => {
                    var giftCard: any;

                    if (checkGiftCardIdInSale && this.isGiftCardInSale(giftCards)) {
                        return;
                    }

                    this.registerContext.hideCheckoutButtons = true;
                    this.existing = false;

                    if (giftCards.length > 0) {
                        giftCard = this.getStandardGiftCard();
                        var checkResponse = checkGiftCardUsageRestriction(giftCards, giftCard);
                        giftCard = checkResponse.giftCard;
                        giftCards = checkResponse.giftCards;
                        if (!checkResponse.isMatch) {
                            checkResponse = checkGiftCardFutureDate(giftCards, giftCard);
                            giftCard = checkResponse.giftCard;
                        }
                        if (!checkResponse.isMatch) {
                            checkResponse = checkGiftCardWithBalance(giftCards, giftCard);
                            giftCard = checkResponse.giftCard;
                        }
                        if (!checkResponse.isMatch) {
                            /* existingGiftCard.remainingAmount == 0 */
                            checkResponse = checkReuseGiftCard(giftCards, giftCard);
                            giftCard = checkResponse.giftCard;
                        }
                        if (!giftCard) {
                            return;
                        }
                    }
                    else {
                        giftCard = this.getDefaultGiftCard();
                    }
                    this.giftCard = giftCard;
                    this.setEndDate();
                    if (this.giftCard && !this.saleLine) {
                        if (!this.existing) {
                            this.applySettingForStandardGCNumberOfWeeksExpiration();
                        }
                        if (this.giftCard.giftCardTypeId) {
                            this.registerContext.giftCardTypeChanged(this.giftCard.giftCardTypeId);
                        }
                    }
                });
            } else {
                this.registerContext.hideCheckoutButtons = true;
                this.existing = false;

                this.giftCard = this.getDefaultGiftCard();;
                this.setEndDate();
                if (this.giftCard && !this.saleLine) {
                    this.applySettingForStandardGCNumberOfWeeksExpiration();
                    if (this.giftCard.giftCardTypeId) {
                        this.registerContext.giftCardTypeChanged(this.giftCard.giftCardTypeId);
                    }
                }
            }
        }

        setDefaultGiftCardType() {
            let defaultGCTypeId = this.registerContext.appSettings["APP_BUSINFOSETTINGS"].registerSettings.defaultGiftCardType;
            if (defaultGCTypeId) {
                let giftCardDefaultType = _(this.giftCardTypesAll).where({ id: defaultGCTypeId });
                if (giftCardDefaultType && giftCardDefaultType.length > 0) {
                    this.dataService.getItem("giftCardType", new Guid(defaultGCTypeId))
                        .then((response) => {
                            if (response) {
                                let gcType = <Model.GiftCardType>response;
                                if (gcType.objectState === Model.ObjectStateEnum.Active) {
                                    this.defaultGiftCardType = gcType;
                                }
                            }
                        });
                }
            }
        }

        getDefaultGiftCard() {
            if (this.saleLine) {
                return this.giftCard;
            }

            if (this.defaultGiftCardType && !(this.defaultGiftCardType.isPromo && this.saleType == Model.SalesTypeEnum.BulkGiftCard)) {
                    return {
                        giftCardNumber: this.giftCardNumber,
                        startDate: moment().toDate(),
                        remainingAmount: this.defaultGiftCardType.valuePrice,
                        price: this.defaultGiftCardType.defaultPrice,
                        giftCardType: this.defaultGiftCardType,
                        giftCardTypeId: this.defaultGiftCardType.id
                    };
            }
            return this.getStandardGiftCard();
        }

        getStandardGiftCard() {
            return {
                giftCardNumber: this.giftCardNumber,
                startDate: moment().toDate(),
                remainingAmount: 0,
                price: 0,
                giftCardType: {
                    displayName: this.$translate.instant("LABEL_STANDARD_GIFT_CARD_TYPE")
                }
            };
        }

        getGiftCardTypesAll(): ng.IPromise<any> {
            let defer = this.registerContext.$q.defer();
            this.giftCardTypeFilters = [
                {
                    id: 0,
                    displayName: this.$translate.instant("LABEL_ALL")
                },
                {
                    id: 1,
                    displayName: this.$translate.instant("LABEL_NON_PROMO")
                },
                {
                    id: 2,
                    displayName: this.$translate.instant("LABEL_PROMO")
                }
            ];
            this.giftCardTypeFilter = this.giftCardTypeFilters[1];
            let request = {
                pageNumber: 0,
                itemsPerPage: 1000,
                criteria:
                {
                    IncludeInvalid: false
                }
            }
            this.dataService.getListPaged("giftCardType", request)
                .then((response) => {
                    response.unshift({
                        displayName: this.$translate.instant("LABEL_STANDARD_GIFT_CARD_TYPE"),
                        isPromo: false
                    });
                    this.giftCardTypesAll = response;
                    this.filterGiftCardTypes();
                    defer.resolve();
                });
            return defer.promise;
        }

        useAnonymousClient(selectedGiftCard) {
            selectedGiftCard.client = this.anonymousClient;
            selectedGiftCard.clientType = Model.ClientTypeEnum.AnonymousOther;
            selectedGiftCard.clientId = undefined;
        }

        useSelectedClient(selectedGiftCard) {
            if (this.registerContext.selectedClient) {
                selectedGiftCard.client = this.registerContext.selectedClient;
                selectedGiftCard.clientId = this.registerContext.selectedClient.id;
                selectedGiftCard.clientType = Model.ClientTypeEnum.Client;
            } else {
                this.useAnonymousClient(selectedGiftCard);
            }
        }

        clientChanged() {
            if (this.giftCard.client && this.giftCard.client.id) {
                this.giftCard.clientId = this.giftCard.client.id;
                this.giftCard.clientType = Model.ClientTypeEnum.Client;
            }

            if (this.registerContext.isRefundMode && this.registerContext.selectedClientType === Model.ClientTypeEnum.Client) {
                this.client = this.registerContext.selectedClient;
                this.refundClientChange();
            }
        }

        minEndDate: Date;
        getMinEndDate() {
            if (!this.minEndDate) {
                this.minEndDate = moment().endOf("day").toDate();
                if (this.giftCard && moment(this.giftCard.startDate).startOf("day") >= moment().startOf("day")) {
                    this.minEndDate = moment(this.giftCard.startDate).endOf("day").toDate();
                }
            }
            return this.minEndDate;
        }

        selectGiftCardType(giftCardTypeItem: Model.GiftCardType) {
            if (giftCardTypeItem) {
                if (giftCardTypeItem.id) {
                    this.dataService.getItem("giftCardType", new Guid(giftCardTypeItem.id))
                        .then((response: Model.GiftCardType) => {
                            this.giftCard.giftCardType = response;
                            this.giftCard.price = response.defaultPrice;
                            this.giftCard.remainingAmount = response.valuePrice;
                            this.giftCard.value = response.valuePrice;
                            this.setEndDate();
                        });
                    this.giftCard.giftCardTypeId = giftCardTypeItem.id;
                    this.isPriceChanged = false;
                } else {
                    this.giftCard.giftCardType = giftCardTypeItem;
                    this.giftCard.giftCardTypeId = undefined;
                    this.giftCard.price = 0;
                    this.giftCard.remainingAmount = 0;
                    this.giftCard.endDate = undefined;
                    this.applySettingForStandardGCNumberOfWeeksExpiration();
                }
                this.goBack();
            } else {
                if (!this.giftCardTypesAll) {
                    this.getGiftCardTypesAll();
                }
                this.stage = GiftCardStageEnum.GiftCardType;
                if (this.saleType == Model.SalesTypeEnum.BulkGiftCard) {
                    this.giftCardTypeFilter.id = 1;
                    this.giftCardTypeFilterChanged();
                }
            }
            this.registerContext.giftCardTypeChanged(this.giftCard.giftCardTypeId);
        }

        giftCardTypeFilterChanged() {
            this.filterGiftCardTypes();
        }

        private applySettingForStandardGCNumberOfWeeksExpiration() {
            if (this.registerContext.numberOfWeeksGFExpiresAfterPurchase === 0 ||
                (this.giftCard.giftCardType && this.giftCard.giftCardType.id)) {
                    return;
            }

            this.giftCard.giftCardType.weeksValidFor = this.registerContext.numberOfWeeksGFExpiresAfterPurchase;
            this.setEndDate();
        }

        private filterGiftCardTypes() {
            switch (this.giftCardTypeFilter.id) {
                case 0:
                    this.giftCardTypes = this.giftCardTypesAll;
                    break;
                case 1:
                    this.giftCardTypes = _(this.giftCardTypesAll).where({ isPromo: false });
                    break;
                case 2:
                    this.giftCardTypes = _(this.giftCardTypesAll).where({ isPromo: true });
                    break;
            }
        }

        startDateChanged() {
            this.minEndDate = null;
            this.setEndDate();
        }

        private setEndDate() {
            if (this.giftCard.giftCardType.weeksValidFor) {
                let newEndDate = moment(this.giftCard.startDate)
                    .add("weeks", this.giftCard.giftCardType.weeksValidFor);
                this.giftCard.endDate = newEndDate < moment().endOf("day") ? moment().toDate() : newEndDate.toDate();
            }
            else if (this.giftCard.giftCardType.weeksValidFor == 0) {
                this.giftCard.endDate = undefined;
            }
            else if (this.giftCard.endDate && this.giftCard.endDate < this.giftCard.startDate) {
                this.giftCard.endDate = this.giftCard.startDate;
            }
        }

        selectSingle() {
            this.stage = GiftCardStageEnum.Single;            
        }

        selectBulk() {
            this.stage = GiftCardStageEnum.Bulk;
            this.saleType = Model.SalesTypeEnum.BulkGiftCard;
        }

        goBack() {
            if (this.stage === GiftCardStageEnum.GiftCardType) {
                this.stage = this.saleType === Model.SalesTypeEnum.BulkGiftCard ? GiftCardStageEnum.Bulk : GiftCardStageEnum.Single;
                return;
            }
            this.reset();
        }

        canGoBack() {
            return (this.initialStage === GiftCardStageEnum.Quantity ||
                this.stage === GiftCardStageEnum.GiftCardType) && this.stage !== GiftCardStageEnum.Quantity;
        }

        reset(initialStage?: Meevo.Plugins.Register.GiftCardStageEnum) {
            this.initialStage = initialStage || this.initialStage || Meevo.Plugins.Register.GiftCardStageEnum.Quantity;
            if (!this.registerContext.isRefundMode && !this.registerContext.sellGiftCardPermission) {
                this.registerContext.showEmptySection();
            }
            this.giftCard = undefined;
            this.giftCardNumberEntered = false;
            this.giftCardNumber = undefined;
            this.giftCardId = undefined;
            this.autoGenerateGcNumber = false;
            this.saleType = null;
            if (this.initialStage === GiftCardStageEnum.Bulk) {
                this.saleType = Model.SalesTypeEnum.BulkGiftCard;
            }
            this.quantity = 2;
            this.saleLine = null;

            this.pregeneratedGiftCardItem = undefined;

            this.stage = this.initialStage;

            if (!this.registerContext.isRefundMode) {
                this.registerContext.hideCheckoutButtons = false;

            }

            this.client = null;
            this.transactionSaleLines.clearSearch();
            this.bulkSaleLines.clearSearch();
            this.request = null;
            this.setRefundType();
            this.scannedTransactionId = "";

            this.selectedReferredByEnum = null;
            this.selectedReferredByDetail = {
                id: null,
                displayName: null,
                referredBy: null
            };

            if (this.registerContext.isRefundMode && this.registerContext.selectedClientType === Model.ClientTypeEnum.Client) {
                this.client = this.registerContext.selectedClient;
                this.refundClientChange();
            }
            this.getNonStandardDateSecurityKey();
        }

        private setRefundType() {
            if (!this.registerContext.isRefundMode) {
                return;
            }

            this.refundTypeList = [];
            this.refundType = undefined;
            const singleGiftCardKey = Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_REFUNDGIFTCARD;
            const bulkGiftCardKey = Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_REFUNDBULKGIFTCARD;
            let keysToCheck: string[] = [
                singleGiftCardKey,
                bulkGiftCardKey,
            ];

            this.registerContext.securityService.checkAndCache(keysToCheck).then((response) => {
                this.canRefundSingle = _(response).findWhere({ key: singleGiftCardKey });
                this.canRefundBulk = _(response).findWhere({ key: bulkGiftCardKey });

                // If one permission is deny and the other is hide, then the deny permission will be 
                // selected b/c they must have elevated when pressing the button on the refund options pane
                // to get to this screen
                if (this.canRefundSingle.securityAccess === Meevo.Model.SecurityAccessEnum.Grant ||
                    this.canRefundSingle.securityAccess === Meevo.Model.SecurityAccessEnum.Deny) {
                    this.refundTypeList.push(this.singleRefundType);
                    if (this.canRefundSingle.securityAccess === Meevo.Model.SecurityAccessEnum.Grant ||
                        this.canRefundBulk.securityAccess === Meevo.Model.SecurityAccessEnum.Hide) {
                        this.refundType = GiftCardRefundTypeEnum.Single;
                    }
                }

                if (this.canRefundBulk.securityAccess === Meevo.Model.SecurityAccessEnum.Grant ||
                    this.canRefundBulk.securityAccess === Meevo.Model.SecurityAccessEnum.Deny) {
                    this.refundTypeList.push(this.multiRefundType);
                    if ((this.canRefundSingle.securityAccess !== Meevo.Model.SecurityAccessEnum.Grant &&
                        this.canRefundBulk.securityAccess === Meevo.Model.SecurityAccessEnum.Grant) ||
                        (this.canRefundSingle.securityAccess === Meevo.Model.SecurityAccessEnum.Hide &&
                        this.canRefundBulk.securityAccess === Meevo.Model.SecurityAccessEnum.Deny)) {
                        this.refundType = GiftCardRefundTypeEnum.Bulk;
                    }
                }
                
                this.refundTypeChanged(true);
            });
        }

        clearReferredBy() {
            this.selectedReferredByDetail = {
                id: null,
                displayName: null,
                referredBy: Model.Guard.isNothing(this.selectedReferredByEnum) ? null : this.selectedReferredByEnum
            };
        }

        referredByChanged() {
            if (this.selectedReferredByDetail !== undefined) {
                this.selectedReferredByDetail.referredBy = this.selectedReferredByEnum;
                this.selectedReferredByDetail.referralDisplayName = this.selectedReferredByDetail.displayName;
            }
        }

        showStudentTeacherReferrerAlert(referredBy: Meevo.Model.ReferredByEnum, contentKey : string) : void {
            if (referredBy && !this.canViewStudentTeacherModule) {
                this.modalService.alert(contentKey, Meevo.Components.Modal.ModalTranslationModes.Translate, false, { okButtonContentKey: 'LABEL_OK' });
            }
        }

        // --- REFUND ---

        transactionSaleLines: any;
        bulkSaleLines: any;

        private getRefundRequest() {
            return {
                pageNumber: 0,
                itemsPerPage: 25,
                criteria: {
                    clientIds: [],
                    giftCardNumber: null,
                    isRefundMode: null,
                    activeOnly: null,
                    includeAuthorizationPaymentRequest: true,
                }
            };
        }

        private onSearch = () => {
            this.setRefundAmounts();
        }

        request;
        refundClientChange() {
            if (!this.client) {
                return;
            }

            this.request = this.getRefundRequest();
            this.request.criteria.clientIds = [ this.client.id ];

            this.refundTypeChanged();
            this.setRefundAmounts();
        }

        refundGiftCardNumberChange() {
            if (!this.giftCardNumber || this.giftCardNumber.trim().length === 0) {
                return;
            }

            this.request = this.getRefundRequest();
            this.request.criteria.giftCardNumber = this.giftCardNumber;

            this.refundTypeChanged();
            this.setRefundAmounts();
        }

        getRefundSubTotal(): number {
            let sum = 0;
            let rows = _(this.transactionSaleLines.loadedPages).flatten();
            _(rows).each((item) => {
                if (item && item.refundAmount) {
                    sum += +item.refundAmount;
                }
            });
            return this.registerContext.normalizeDecimalPlaces(sum);
        }

        getRefundTax(): number {
            return 0;
        }

        getRefundTotal(): number {
            return this.getRefundSubTotal() + this.getRefundTax();
        }

        private getRefundSaleLine(giftCard): Model.SaleLine {
            const existingSaleLine = this.registerContext.sale.saleLines
                .filter(saleLine => saleLine.isRefund && saleLine.saleType === Model.SalesTypeEnum.ReloadGiftCard)
                .find(refundSaleLines => refundSaleLines.item.id === giftCard.id);

            return existingSaleLine;
        }

        private getTransactionRefundSaleLine(giftCard): Model.SaleLine { 
            const existingSaleLine = this.getRefundSaleLine(giftCard);
        
            if (existingSaleLine && 
                existingSaleLine.refundLocationId &&
                existingSaleLine.refundSaleDate &&
                existingSaleLine.refundSaleId &&
                existingSaleLine.refundSaleLineId) {
                return existingSaleLine;
            }

            return null;
        }

        setRefundAmounts() {
            let rows = _(this.transactionSaleLines.loadedPages).flatten();

            _(rows).each((giftCard) => {
                if (!giftCard) {
                    return;
                }

                const existingSaleLine = this.getRefundSaleLine(giftCard);

                giftCard.refundAmount = Math.abs(existingSaleLine ? existingSaleLine.finalPrice : 0);
                giftCard.isRefundSelected = existingSaleLine ? true : false;
            });

            this.refundSubTotal = this.getRefundSubTotal();
            this.refundTax = this.getRefundTax();
        }

        canApplyRefund(): boolean {
            // allow refund if refund amount > 0
            if (this.refundSubTotal != undefined && this.refundTax != undefined && 
                this.registerContext.addNormalizedNumbers(this.refundSubTotal, this.refundTax) > 0) {
                return true;
            }

            // if refund amount = 0, then enable button only for allowable $0 refunds
            if (this.refundType === GiftCardRefundTypeEnum.Single) {
                const refundsExist = _.chain(this.transactionSaleLines.loadedPages)
                    .flatten()
                    .any((giftCard) => giftCard && giftCard.isRefundSelected && giftCard.refundAmount != undefined && this.canRefund(giftCard))
                    .value();

                if (refundsExist) {
                    return true;
                }
            } else {
                const refundsExist = _.chain(this.bulkSaleLines.loadedPages)
                    .flatten()
                    .any((saleLine) => saleLine.isRefund)
                    .value();

                if (refundsExist) {
                    return true;
                }
            }

            return false;
        }

        createGiftCardRefund(giftCard) {
            let giftCardSaleLineItem = new Meevo.Plugins.Register.GiftCardSaleLineItem({
                displayName: this.$translate.instant("LABEL_GIFT_CARD"),
                id: giftCard.id,
            });

            giftCardSaleLineItem.clientGiftCard = giftCard;

            let saleItem: Model.SaleLine = {
                quantity: 1,
                baseItemPrice: this.getBasePrice(giftCard), 
                finalItemPrice: giftCard.refundAmount,
                clientId: null,
                clientType: null,
                saleType: Model.SalesTypeEnum.ReloadGiftCard,
                employeeId: giftCard.employeeId,
                employee: giftCard.employee,
                employeeDisplayName: giftCard.employee != null ? giftCard.employee.displayName : null,
                isRefund: true,
                item: giftCardSaleLineItem,
            };

            saleItem.basePrice = saleItem.baseItemPrice;
            saleItem.finalPrice = saleItem.finalItemPrice;

            saleItem.client = this.client;

            return saleItem;
        }

        getBasePrice(giftCard): number {
            const refundAmount = this.registerContext.normalizeDecimalPlaces(giftCard.refundAmount);
            const remainingRefundAmount = this.registerContext.normalizeDecimalPlaces(giftCard.remainingRefundAmount);
            const remainingAmount = this.registerContext.normalizeDecimalPlaces(giftCard.remainingAmount);

            return refundAmount == remainingRefundAmount || (refundAmount == 0 && remainingAmount > 0) 
                ? remainingAmount 
                : 0;
        }

        createBulkGiftCardRefund(saleLine) {
            let bulkGiftCardSaleLineItem = new Meevo.Plugins.Register.GiftCardBulkSaleLineItem({
                displayName: this.$translate.instant("LABEL_MULTI_GIFT_CARD"),
                id: saleLine.id,
                clientGiftCard: {  
                    startDate: moment().toDate() // needed otherwise get date overflow in udt
                },
                giftCardNumberStarting: saleLine.item.giftCardNumberStarting,
                giftCardNumberEnding: saleLine.item.giftCardNumberEnding
            });

            let refundSaleLine: Model.SaleLine = {
                quantity: saleLine.quantity,
                baseItemPrice: saleLine.baseItemPrice,
                finalItemPrice: saleLine.finalItemPrice,
                clientId: null,
                clientType: null,
                saleType: Model.SalesTypeEnum.BulkGiftCard,
                employeeId: saleLine.employeeId,
                employee: saleLine.employee,
                employeeDisplayName: saleLine.employee != null ? saleLine.employee.displayName : null,
                isRefund: true,
                locationId: saleLine.locationId,
                saleDate: saleLine.saleDate,
                saleId: saleLine.saleId,
                id: saleLine.id,
                transactionId: saleLine.transactionId,
                item: bulkGiftCardSaleLineItem,
            };

            refundSaleLine.basePrice = saleLine.basePrice;
            refundSaleLine.finalPrice = saleLine.finalPrice;

            refundSaleLine.client = this.client;

            return refundSaleLine;
        }

        canRefund(giftCard) {
            return giftCard.refundAmount > 0 || (giftCard.refundAmount == 0 && giftCard.remainingAmount > 0 && giftCard.remainingRefundAmount == 0);
        }

        applyRefundItems() {
            let refunds;
            if (this.refundType === GiftCardRefundTypeEnum.Single) {
                refunds = _.chain(this.transactionSaleLines.loadedPages)
                    .flatten()
                    .filter((giftCard) => giftCard && giftCard.isRefundSelected && giftCard.refundAmount != undefined && this.canRefund(giftCard))
                    .each((giftCard) => {
                        if (this.getTransactionRefundSaleLine(giftCard)) {
                            return;
                        }

                        let saleLine = this.createGiftCardRefund(giftCard);

                        this.registerContext.addRefundSaleLine(saleLine, Model.SalesTypeEnum.ReloadGiftCard);
                    })
                    .value();
            }
            else {
                refunds = _.chain(this.bulkSaleLines.loadedPages)
                    .flatten()
                    .filter((saleLine) => saleLine.isRefund)
                    .each((saleLine) => {
                        let refundSaleLine = this.createBulkGiftCardRefund(saleLine);

                        this.registerContext.addRefundSaleLine(refundSaleLine, Model.SalesTypeEnum.BulkGiftCard);
                    })
                    .value();
            }
            if (refunds.length > 0) {
                this.registerContext.recalculateSale();
            }
        }

        isDirty() {
            return !this.registerContext.isRefundMode && ((!angular.isUndefined(this.giftCardNumber) && this.giftCardNumber.trim() != "") || this.autoGenerateGcNumber);
        }

        refundAmountChange(giftCard) {
            if (giftCard.refundAmount < 0) {
                giftCard.refundAmount = 0;
            }

            if (giftCard.refundAmount > giftCard.remainingRefundAmount) {
                this.modalService.alert("MESSAGE_REFUND_AMOUNT_EXCEED_VALIDATION");
                giftCard.refundAmount = giftCard.remainingRefundAmount;
            }

            this.refundSubTotal = this.getRefundSubTotal();
            this.refundTax = this.getRefundTax();
        }

        isRefundChanged(saleLine) {
            if (saleLine.isRefund) {
                if (this.registerContext.isMismatch(this.registerContext.getAuthorizationPaymentRequestId(this.registerContext.sale), saleLine.authorizationPaymentRequestId) ||
                    this.hasAuthorizationPaymentRequestIdMismatch(_(this.transactionSaleLines.loadedPages).flatten().filter(line => line.isRefund))
                ) {
                    this.registerContext.displayRefundMismatchMessage(false, true);
                    saleLine.isRefund = false;
                    return;
                }

                this.refundSubTotal = this.registerContext.addNormalizedNumbers(this.refundSubTotal, saleLine.finalPrice);
            } else {
                this.refundSubTotal = this.registerContext.subtractNormalizedNumbers(this.refundSubTotal, saleLine.finalPrice);
            }
        }

        refundTransaction() {
            this.registerContext.getSaleLinesToRefundFromTransactionId(this.scannedTransactionId).then(() => { this.scannedTransactionId = ""; });
        }
        autoGenerateGc() {
            this.giftCardNumber = undefined;
            if (!this.saleLine) {
                this.giftCard = undefined;

                this.giftCardNumberChange();
            }
        }
        nonStandardActiveOnDateSecurityKey: string;
        nonStandardExpiresOnDateSecurityKey: string;

        getNonStandardDateSecurityKey() {
            if (this.nonStandardActiveOnDateSecurityKey && this.nonStandardExpiresOnDateSecurityKey) {
                return;
            }
            let keysToCheck: string[] = [
                Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_GIFTCARD_GIFTCARDTYPE + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_GIFTCARDS_CHANGEVALIDFROMDATES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_GIFTCARDS_CHANGEEXPIREDDATES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
            ];
            this.securityService.checkAndCache(keysToCheck).then((response) => {
                let giftCardTypeItem = _.findWhere(response, { key: Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_GIFTCARD_GIFTCARDTYPE + Meevo.Components.Common.SecurityParts.KEY_PART_READ });
                let changeActiveOnDateItem = _.findWhere(response, { key: Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_GIFTCARDS_CHANGEVALIDFROMDATES + Meevo.Components.Common.SecurityParts.KEY_PART_READ });
                let changeExpiresOnDateItem = _.findWhere(response, { key: Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_GIFTCARDS_CHANGEEXPIREDDATES + Meevo.Components.Common.SecurityParts.KEY_PART_READ });

                // Active On Date security
                this.nonStandardActiveOnDateSecurityKey = this.getDateSecurityKey(giftCardTypeItem, changeActiveOnDateItem);

                // Expires On Date security
                this.nonStandardExpiresOnDateSecurityKey = this.getDateSecurityKey(giftCardTypeItem, changeExpiresOnDateItem);
            });
        }

        private getDateSecurityKey(giftCardTypeItem: Model.SecurityItem, changeDatesItem: Model.SecurityItem): string {
            if (giftCardTypeItem && giftCardTypeItem.securityAccess === Meevo.Model.SecurityAccessEnum.Hide) {
                return giftCardTypeItem.key;
            }
            else if (changeDatesItem && changeDatesItem.securityAccess === Meevo.Model.SecurityAccessEnum.Hide) {
                return changeDatesItem.key;
            }
            else if (giftCardTypeItem && giftCardTypeItem.securityAccess === Meevo.Model.SecurityAccessEnum.Deny) {
                return giftCardTypeItem.key;
            }
            else if (changeDatesItem && changeDatesItem.securityAccess === Meevo.Model.SecurityAccessEnum.Deny) {
                return changeDatesItem.key;
            }
            else {
                return changeDatesItem.key;
            }
        }

        checkGCRefundRestriction(giftCard: any): boolean {
            if (this.registerContext.appSettings["APP_BUSINFOSETTINGS"].registerSettings.restrictOffsiteGiftCardRefund) {
                if (giftCard && giftCard.saleLocationId !== this.registerContext.identityService.locationId) {
                    return true;
                }
            }
            return false;
        }

        showRestrictionMessage(giftCard: any) {
            if (this.checkGCRefundRestriction(giftCard)) {
                this.modalService.alert('LABEL_GIFT_CARD_REFUND_RESTRICTION');
                return;
            }
        }

        canChangeGiftCardCategory() {
            return this.saleType != Model.SalesTypeEnum.BulkGiftCard;
        }

        isGiftCardInSale(giftCards) {
            if (giftCards.length !== 1) {
                return false;
            }

            const isGiftCardInSale = _(this.registerContext.sale.saleLines)
                .any(sl => (sl.item as any).clientGiftCard && (sl.item as any).clientGiftCard.id === giftCards[0].id);
            if (isGiftCardInSale) {
                this.showGiftCardErrorMessageAndReset("MESSAGE_GIFT_CARD_MUST_BE_UNIQUE");
                return true;
            }
        }

        generateGiftCardNumber() {
            this.pregeneratedGiftCardItem = {};
            let payload: any = this.stage === GiftCardStageEnum.Bulk ?
                this.getSaleLine(Model.SalesTypeEnum.BulkGiftCard, null, null, true) :
                this.getSaleLine(Model.SalesTypeEnum.GiftCard, null, null, true);

            this.dataService.customMethodData('api/ClientGiftCard/GiftCardNumber', 'POST', payload).then(res => {
                if (!res || !res.data) {
                    this.pregeneratedGiftCardItem = undefined;
                    return;
                }

                this.pregeneratedGiftCardItem = res.data;
                this.pregeneratedGiftCardItem.displayName = this.getPregeneratedGiftCardNumbers(payload.saleType);
            }).catch(() => this.pregeneratedGiftCardItem = undefined);
        }

        getPregeneratedGiftCardNumbers(saleType: Model.SalesTypeEnum) {
            return saleType === Model.SalesTypeEnum.GiftCard ?
                this.pregeneratedGiftCardItem.giftCardNumber :
                `${this.pregeneratedGiftCardItem.giftCardNumberStarting} - ${this.pregeneratedGiftCardItem.giftCardNumberEnding}`;
        }

        assignGiftCardNumber(saleType: Model.SalesTypeEnum, item?: any) {
            if (this.giftCardNumber && !this.autoGenerateGcNumber) {
                this.pregeneratedGiftCardItem = undefined;
            }

            if (!this.pregeneratedGiftCardItem) {
                return;
            }

            item = item || this.giftCard;
            item.giftCardNumber = this.pregeneratedGiftCardItem.giftCardNumber;

            if (item.clientGiftCard) {
                item.clientGiftCard.giftCardNumber = item.giftCardNumber;
            }

            if (saleType == Model.SalesTypeEnum.BulkGiftCard) {
                item.giftCardNumberStarting = this.pregeneratedGiftCardItem.giftCardNumberStarting;
                item.giftCardNumberEnding = this.pregeneratedGiftCardItem.giftCardNumberEnding;
            }
        }

        resetUnmaskedGcNumbers() {
            this.pregeneratedGiftCardItem = undefined;
        }

        checkGiftCard(giftCard) {
            if (this.refundType === GiftCardRefundTypeEnum.Single) {
                const existingSaleLine = this.getTransactionRefundSaleLine(giftCard);
                if (existingSaleLine) {
                    giftCard.refundAmount = Math.abs(existingSaleLine.finalPrice);
                    this.modalService.alert("MESSAGE_TRANSACTION_GIFT_CARD_REFUND");
                    return false;
                }
            }

            return true;
        }

        postCheckGiftCard(giftCard) {
            if (giftCard.isRefundSelected) {
                if (this.registerContext.isMismatch(this.registerContext.getAuthorizationPaymentRequestId(this.registerContext.sale), giftCard.authorizationPaymentRequestId) ||
                    this.hasAuthorizationPaymentRequestIdMismatch(_(this.transactionSaleLines.loadedPages).flatten().filter(line => line.isRefund || line.isRefundSelected))
                ) {
                    this.registerContext.displayRefundMismatchMessage(false, true);
                    giftCard.isRefundSelected = false;
                    return;
                }
            }
        }        
    }
}